import type {
  OrganisationCreatePayload,
  OrganisationDto,
  OrganisationMemberCreatePayload,
  OrganisationMemberDto,
  OrganisationMemberUpdatePayload,
  OrganisationUpdatePayload,
} from "../types/organisation";
import {
  normalizeOrganisation,
  normalizeOrganisationMembers,
  normalizeOrganisationsList,
} from "../lib/organisations/normalize";
import { apiRequest } from "./client";

export function fetchOrganisations(): Promise<OrganisationDto[]> {
  return apiRequest<unknown>("/api/v1/organisations").then(
    normalizeOrganisationsList,
  );
}

export function fetchOrganisation(id: number): Promise<OrganisationDto> {
  return apiRequest<unknown>(`/api/v1/organisations/${id}`).then((body) => {
    const organisation = normalizeOrganisation(body);
    if (!organisation) {
      throw new Error("Некорректный ответ организации");
    }
    return organisation;
  });
}

export function createOrganisation(
  payload: OrganisationCreatePayload,
): Promise<OrganisationDto> {
  return apiRequest<unknown>("/api/v1/organisations", {
    method: "POST",
    body: JSON.stringify(payload),
  }).then((body) => {
    const organisation = normalizeOrganisation(body);
    if (!organisation) {
      throw new Error("Некорректный ответ создания организации");
    }
    return organisation;
  });
}

export function updateOrganisation(
  id: number,
  payload: OrganisationUpdatePayload,
): Promise<OrganisationDto> {
  return apiRequest<unknown>(`/api/v1/organisations/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  }).then((body) => {
    const organisation = normalizeOrganisation(body);
    if (!organisation) {
      throw new Error("Некорректный ответ обновления организации");
    }
    return organisation;
  });
}

export function deleteOrganisation(id: number): Promise<void> {
  return apiRequest<void>(`/api/v1/organisations/${id}`, {
    method: "DELETE",
  });
}

export function fetchOrganisationMembers(
  organisationId: number,
): Promise<OrganisationMemberDto[]> {
  return apiRequest<unknown>(
    `/api/v1/organisations/${organisationId}/members`,
  ).then(normalizeOrganisationMembers);
}

export function addOrganisationMember(
  organisationId: number,
  payload: OrganisationMemberCreatePayload,
): Promise<OrganisationMemberDto> {
  return apiRequest<unknown>(
    `/api/v1/organisations/${organisationId}/members`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  ).then((body) => {
    const member = normalizeOrganisationMembers([body])[0];
    if (!member) {
      throw new Error("Некорректный ответ добавления участника");
    }
    return member;
  });
}

export function updateOrganisationMember(
  organisationId: number,
  userId: number,
  payload: OrganisationMemberUpdatePayload,
): Promise<OrganisationMemberDto> {
  return apiRequest<unknown>(
    `/api/v1/organisations/${organisationId}/members/${userId}`,
    {
      method: "PATCH",
      body: JSON.stringify(payload),
    },
  ).then((body) => {
    const member = normalizeOrganisationMembers([body])[0];
    if (!member) {
      throw new Error("Некорректный ответ обновления участника");
    }
    return member;
  });
}

export function removeOrganisationMember(
  organisationId: number,
  userId: number,
): Promise<void> {
  return apiRequest<void>(
    `/api/v1/organisations/${organisationId}/members/${userId}`,
    { method: "DELETE" },
  );
}
